import script from "./StreamingApi.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamingApi.vue?vue&type=script&setup=true&lang=js"

import "./StreamingApi.vue?vue&type=style&index=0&id=2973b290&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2973b290"]])

export default __exports__